// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"c2708ed5","381":"b3c1ea42","542":"761842f2","635":"4b0e4c0e","727":"37e60dca","737":"0c810dc1","836":"ef7e1016","900":"1b7171e0"}[chunkId] + ".chunk.js";
};